// 開示カウンセリング一覧レスポンス
export class DsclstResponce {
    constructor(SessionGrpPk, ApplyDt, SessionGrpNo, ServiceNm, ClientNm, SessionGrpStatus, CounselorNm, SessionGrpRsvDateS, SessionGrpRsvDateE) {
        this.SessionGrpPk = SessionGrpPk;
        (this.ApplyDt = ApplyDt), (this.SessionGrpNo = SessionGrpNo), (this.ServiceNm = ServiceNm), (this.ClientNm = ClientNm), (this.SessionGrpStatus = SessionGrpStatus), (this.CounselorNm = CounselorNm), (this.SessionGrpRsvDateS = SessionGrpRsvDateS), (this.SessionGrpRsvDateE = SessionGrpRsvDateE);
    }
}

// 開示カウンセリング詳細レスポンス
export class DscdtlResponce {
    constructor(SessionGrpNo = '', SessionGrpStatus = '', ApplyDt = '', ApplicantNm = '', ServiceNm = '', ClientNm = '', ReportingUsers = [], SessionGrpApplyNote = '', CounselorNm = '', SessionGrpRsvDateS = '', SessionGrpRsvDateE = '', ReserveList = [], AllowCansel = true) {
        this.SessionGrpNo = SessionGrpNo;
            this.SessionGrpStatus = SessionGrpStatus;
            this.ApplyDt = ApplyDt;
            this.ApplicantNm = ApplicantNm;
            this.ServiceNm = ServiceNm;
            this.ClientNm = ClientNm;
            this.ReportingUsers = ReportingUsers;
            this.SessionGrpApplyNote = SessionGrpApplyNote;
            this.CounselorNm = CounselorNm;
            this.SessionGrpRsvDateS = SessionGrpRsvDateS;
            this.SessionGrpRsvDateE = SessionGrpRsvDateE;
            this.ReserveList = ReserveList.map((item) => new Reserve(item.ReservationPk, item.ReservationNo, item.ReservationStatus, item.ReservationDt, item.CounselorNm, item.ReportOutput));
            this.AllowCansel = AllowCansel;
    }
}
export class Reserve {
    constructor(ReservationPk = '', ReservationNo = '', ReservationStatus = '', ReservationDt = '', CounselorNm = '', ReportOutput = true) {
        this.ReservationPk = ReservationPk;
        this.ReservationNo = ReservationNo;
        this.ReservationStatus = ReservationStatus;
        this.ReservationDt = ReservationDt;
        this.CounselorNm = CounselorNm;
        this.ReportOutput = ReportOutput;
    }
}
// 開示カウンセリングサービス一覧レスポンス
export class DscsvclstResponce {
    constructor(ServicePk, ServiceId, ServiceNm) {
        this.pk = ServicePk;
        this.id = ServiceId;
        this.name = ServiceNm;
    }
    static formApiResponse(data) {
        return new DscsvclstResponce(data.ServicePk, data.ServiceId, data.ServiceNm);
    }
}
